import { siteData } from "../data/intelligence";

export function NoiseWatchlist() { return <section><h2>噪声排除 / 观察名单</h2><p>以下项目不纳入本次五个候选项目的推荐或行动清单。</p><ul>{siteData.watchlist.map((item) => <li key={item.name}><strong>{item.name}</strong>：{item.reason} <a href={item.url} target="_blank" rel="noopener noreferrer">来源 · 观察证据</a></li>)}</ul></section>; }
